<template>
  <v-tooltip v-if="value != undefined" bottom allow-overflow>
    <span slot="activator">
      <v-spacer class="text-xs-left" v-clipboard:copy="value" v-clipboard:success="onCopy">
        {{value.substring(0, displayLength)}}{{displayLength &lt; value.length ? '...' : ''}}
      </v-spacer>
    </span>
    <span><pre>{{ value }}</pre><br/>{{ hint }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'MPayTooltipCopyButton',
  props: ['value', 'displayLength'],
  data: () => ({
    hint: 'Click to copy to Buffer',
  }),
  methods: {
    onCopy() {
      this.hint = 'Value copied to buffer';
      setTimeout(() => {
        this.hint = 'Click to copy to Buffer';
      }, 3000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/MPayTooltipCopyButton.vue